<template>
  <v-container>
    <v-sheet elevation="0">
      <v-toolbar dense elevation="0">
        <v-toolbar-title class="checklist">
          <!--          {{ $route.params.type }} Checklist-->
          Complete the checklist below
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-divider />
      <router-view />
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  name: "CheckListView",
};
</script>

<style scoped>
.checklist {
  font-family: "PT Sans Caption", sans-serif;
  cursor: progress;
}
</style>
